import  axios from "axios"
import Qs from 'qs'
//硬件详情
export function hardwareDetails( params){
	return axios.get('/zypage/SelIntelligentHardware', Qs.stringify(params))
}
//新闻列表
export function newsList(params){
	return axios.post('/zypage/SelNewsInformation', Qs.stringify(params))
	
}
//新闻详情
export function newsDetail( params){
	return axios.post('/zypage/SelNewsInformationId', Qs.stringify(params))
}

//banner
export function banner(params){
	return axios.post('/zypage/GetPic', Qs.stringify(params))
}
//客户列表
export function customer(params){
	return axios.post('/zypage/SelCustomerCaseEntity', Qs.stringify(params))
}
//硬件列表
export function hardware( params){
	return axios.post('/zypage/SelIntelligentHardware', Qs.stringify(params))
}

//公司资质
export function comp(params){
	return axios.post('/zypage/GetGszz', Qs.stringify(params))
}

//产品
export function goods(params){
	return axios.post('/zypage/SelDistribution', Qs.stringify(params))
}

//合作客户
export function selCustomer(params){
	return axios.post('/zypage/Selcooperation', Qs.stringify(params))
}